// extracted by mini-css-extract-plugin
export default {"Container":"MoviesStyle_Container__Mrj51","Form":"MoviesStyle_Form__E1e+9","Pagination":"MoviesStyle_Pagination__gbenB","Loader":"MoviesStyle_Loader__0N-9A"};